import styled from 'styled-components';
import colours from 'theme/atoms/colours';

export const DemoMessage = styled('div')`
  background-color: ${colours.neutral[300]};
  border-radius: 20px;
  box-sizing: border-box;
  color: black;
  display: flex;
  flex-direction: column;
  gap: 20px;
  justify-content: center;
  margin-bottom: 20px;
  padding: 20px;
  top: 0;
  width: 100%;
  z-index: 10;

  svg {
    height: 20px;
    width: 20px;
  }
  svg path {
    fill: black;
  }
`;

export default DemoMessage;
